"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAudioStatus = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const react_1 = require("react");
const room_session_1 = require("../../../context/room_session");
const __1 = require("../../..");
const operators_1 = require("rxjs/operators");
function UserAudioStatus({ videoController, isPipDisplay, cssClassName, }) {
    const theme = (0, ui_react_1.useTheme)();
    const roomSession = (0, room_session_1.useRoomSession)();
    const [ownerUserInfo] = (0, __1.useObservable)(roomSession.user.getUser(videoController.ownerId));
    const [audioEnabled] = (0, __1.useObservable)(videoController.ownerIsLocalUser
        ? roomSession.media.localAudio.enabled
        : roomSession.media.remoteAudio.muted.pipe((0, operators_1.map)(muted => !muted)));
    return (0, react_1.useMemo)(() => {
        if (!ownerUserInfo) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        if (audioEnabled === undefined) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
        return ((0, jsx_runtime_1.jsxs)(Info, Object.assign({ compact: isPipDisplay, className: cssClassName }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: audioEnabled ? 'UnmutedPipIcon' : 'MutedPipIcon', color: audioEnabled ? theme.colors.white : theme.colors.red50, size: 'medium' }), !isPipDisplay && (0, jsx_runtime_1.jsx)(Name, { children: ownerUserInfo === null || ownerUserInfo === void 0 ? void 0 : ownerUserInfo.name })] })));
    }, [
        isPipDisplay,
        ownerUserInfo,
        audioEnabled,
        theme.colors.white,
        theme.colors.red50,
        cssClassName,
    ]);
}
exports.UserAudioStatus = UserAudioStatus;
const Info = (0, ui_react_1.styled)(ui_react_1.Row)(({ compact, theme }) => ({
    userSelect: 'none',
    color: theme.colors.white,
    position: 'absolute',
    bottom: compact ? '5px' : '10px',
    left: compact ? '5px' : '20px',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
    backgroundColor: 'rgba(31, 32, 33, 0.64)',
    borderRadius: '11px',
    padding: '5px',
}));
const Name = (0, ui_react_1.styled)(ui_react_1.AppText)({
    userSelect: 'none',
    color: 'inherit',
    marginLeft: '5px',
    textShadow: '0px 0px 6px rgba(0, 0, 0, 0.5)',
});
//# sourceMappingURL=user_audio_status.js.map